import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '@core';

@Injectable({
  providedIn: 'root',
})
export class CheckoutApiService {
  private readonly apiService = inject(ApiService);

  getCaptureToken(): Observable<string> {
    return this.apiService.get<{ token: string }>('microform/context').pipe(map(({ token }) => token));
  }
}
